import { BigFormWrapper } from "@picovico/ui";
import React from "react";
import {
  FormWrapperExtraProps,
  FormWrapperProps,
} from "@picovico/ui/modules/FormWrapper/FormWrapper";
import { BoxProps, Flex, Link } from "@chakra-ui/react";
import { ForgotPasswordForm2, LoginForm2, RegisterForm2 } from "../Forms";

function WithFormWrapper<P>(
  Component: React.FC,
  defaultFormTitle?: string,
  footer: React.ReactNode = undefined,
) {
  return function formWrappedFunction({
    formTitle,
    image,
    formElementProps,
    ...props
  }: {
    formElementProps?: P;
  } & Pick<FormWrapperProps, "withImage" | "image"> &
    FormWrapperExtraProps & {
      formTitle?: string;
    }) {
    return (
      <BigFormWrapper
        formHeaderProps={{
          mt: "1rem",
        }}
        formTitle={formTitle || defaultFormTitle || "FormTitle"}
        image={image}
        {...props}
        formElement={<Component {...formElementProps} />}
        footer={footer}
      />
    );
  };
}

const LoginFormFooter = (
  <Flex
    bottom={0}
    backgroundColor={"#E2F4FF"}
    p={4}
    justifyContent={"center"}
    alignItems={"center"}
    gap="2px"
    display={{
      base: "flex",
      md: "none",
    }}
  >
    {`New Here   ?`}
    <Link
      textColor={"#007AC0"}
      fontWeight={"bold"}
      ml="2px"
      href="/register"
    >{`${"   Sign Up Here"}`}</Link>
  </Flex>
);

const RegisterFormFooter = (
  <Flex
    bottom={0}
    backgroundColor={"#E2F4FF"}
    p={4}
    justifyContent={"center"}
    alignItems={"center"}
    gap="2px"
    display={{
      base: "flex",
      md: "none",
    }}
  >
    {`Have an account ?`}
    <Link
      textColor={"#007AC0"}
      fontWeight={"bold"}
      ml="2px"
      href="/login"
    >{`${"Login Here"}`}</Link>
  </Flex>
);

const ForgotPasswordFormFooter = (
  <Flex
    bottom={0}
    backgroundColor={"#E2F4FF"}
    p={4}
    justifyContent={"center"}
    alignItems={"center"}
    gap="2px"
    display={{
      base: "flex",
      md: "none",
    }}
  >
    <Link
      textColor={"#007AC0"}
      fontWeight={"bold"}
      ml="2px"
      href="/login"
    >{`${"Return to Login"}`}</Link>
  </Flex>
);

export const BigLoginFormCard = WithFormWrapper<BoxProps>(
  LoginForm2,
  "Sign In",
  LoginFormFooter,
);
export const BigRegisterFormCard = WithFormWrapper<BoxProps>(
  RegisterForm2,
  "Register",
  RegisterFormFooter,
);
export const BigForgotPasswordFormCard = WithFormWrapper<BoxProps>(
  ForgotPasswordForm2,
  "Forgot Password",
  ForgotPasswordFormFooter,
);
